import React from "react";
import LaerdalLogo from "../../images/laerdal_logo.png";

const Footer = () => (
  <footer className="w-full px-6 flex items-center justify-between bg-white border-t border-gray-200 text-xs text-gray-500">
    <span>Copyright © 2026 Laerdal Medical. All Rights Reserved.</span>
    <span className="flex items-center gap-1">Powered by <img src={LaerdalLogo} alt="Laerdal Logo" className="h-12 object-contain" /></span>
  </footer>
);

export default Footer;
